<template>
  <div class="input-wrapper all-day-wrapper main-content">
    <div class="title-wrapper position-relative">
      <span class="ver-center all-day">All-Day</span>
    </div>
    <div class="content-wrapper position-relative checkbox-container">
      <label class="toggle float-right toggle-middle">
        <input
          type="checkbox"
          class="input-btn"
          :value="allDay"
          :checked="allDay"
          @change="toggleAllDay"
        />
        <div class="slide-toggle-middle slide-toggle-appoitment"></div>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      allDay: "getAllDay" // Get if appointment is all day
    })
  },
  methods: {
    ...mapMutations({
      toggleAllDay: "toggleAllDay" // Toggle the all day button
    })
  }
};
</script>

<style scoped>
.all-day-wrapper {
  border-bottom: 1px solid #d0d0d0 !important;
}
.all-day {
  padding-left: 30px;
}
</style>
